import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSweepsAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.75 17C2.75 16.5858 3.08579 16.25 3.5 16.25H15C15.4142 16.25 15.75 16.5858 15.75 17C15.75 17.4142 15.4142 17.75 15 17.75H3.5C3.08579 17.75 2.75 17.4142 2.75 17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18 14.75C16.7574 14.75 15.75 15.7574 15.75 17C15.75 18.2426 16.7574 19.25 18 19.25C19.2426 19.25 20.25 18.2426 20.25 17C20.25 15.7574 19.2426 14.75 18 14.75ZM14.25 17C14.25 14.9289 15.9289 13.25 18 13.25C20.0711 13.25 21.75 14.9289 21.75 17C21.75 19.0711 20.0711 20.75 18 20.75C15.9289 20.75 14.25 19.0711 14.25 17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.25 8C21.25 7.58579 20.9142 7.25 20.5 7.25H9C8.58579 7.25 8.25 7.58579 8.25 8C8.25 8.41421 8.58579 8.75 9 8.75H20.5C20.9142 8.75 21.25 8.41421 21.25 8Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 5.75C7.24264 5.75 8.25 6.75736 8.25 8C8.25 9.24264 7.24264 10.25 6 10.25C4.75736 10.25 3.75 9.24264 3.75 8C3.75 6.75736 4.75736 5.75 6 5.75ZM9.75 8C9.75 5.92893 8.07107 4.25 6 4.25C3.92893 4.25 2.25 5.92893 2.25 8C2.25 10.0711 3.92893 11.75 6 11.75C8.07107 11.75 9.75 10.0711 9.75 8Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconSweepsAlt as ReactComponent };
